(() => {
  const base = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  async function cartPermalink() {
    const cart = await fetch(`${base}cart.js`).then(r => r.json());
    const parts = cart.items.map(i => `${i.variant_id}:${i.quantity}`).join(',');
    return `${location.origin}${base}cart/${parts}`;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-share]');
    if (!btn) return;
    e.preventDefault();

    btn.disabled = true;
    try {
      const url = await cartPermalink();
      await navigator.clipboard.writeText(url);
      btn.textContent = 'Copied!';
      setTimeout(() => (btn.textContent = 'Share cart'), 1200);
    } finally {
      btn.disabled = false;
    }
  });
})();
